import React from 'react';
import { Tab, Responsive } from 'semantic-ui-react';
import axios from 'axios';
import download from 'downloadjs';

import PreviousCertificates from './PreviousCertificates';
import NewStudentCertificate from './NewStudentCertificate';
import DiplomaStatus from './DiplomaStatus';
import Options from '../../DegreeDocumentPrint/Options';
import { getPrintOptionsData } from './PrintOptionsService';
import {
    extractFileNameFromHeaders,
    buildPrintOptionFiltersParamsObject
} from '../../DegreeDocumentPrint/util/util';

import { addPreviewWatermarkToPdf } from './pdfUtils';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class StudentCertificates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentService: localStorage.getItem('activeRole').substr(0, 10) === 'Studentska',
            admin: localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA',
            limitation: this.props.limitation,
            printOptionsData: null,
            ready: false,
            directPrintLoading: false,
            printOptionsFiltersSelectedValues: {
                issueDate: new Date(),
                documentType: '',
                documentReason: '',
                language: '',
                withLogo: true,
                documentVersion: '25/26-',
                alphabet: 'lat'
            }
        };

        this.onPrintOptionsFilterChange = this.onPrintOptionsFilterChange.bind(this);
        this.directPrintOneStudent = this.directPrintOneStudent.bind(this);
        this.getStudentIdFromLocalStorage = this.getStudentIdFromLocalStorage.bind(this);
    }

    componentDidMount() {
        getPrintOptionsData().then(res => {
            this.setState({
                printOptionsData: res,
                ready: true,
                printOptionsFiltersSelectedValues: {
                    issueDate: new Date(),
                    documentType: res.defaultValues && res.defaultValues.documentType ? res.defaultValues.documentType : '',
                    documentReason: res.defaultValues && res.defaultValues.documentReason ? res.defaultValues.documentReason : '',
                    language: res.defaultValues && res.defaultValues.language ? res.defaultValues.language : '',
                    withLogo: true,
                    documentVersion: '25/26-',
                    alphabet: 'lat'
                }
            });
        });
    }

    getStudentIdFromLocalStorage() {
        try {
            const studentStatuses = JSON.parse(localStorage.getItem('studentStatuses'));
            return studentStatuses && studentStatuses.id ? studentStatuses.id : null;
        } catch (e) {
            return null;
        }
    }
    getStudentFromLocalStorage() {
        try {
            return JSON.parse(localStorage.getItem('student'));
        } catch (e) {
            return null;
        }
    }

    onPrintOptionsFilterChange(filterName, filterValue) {
        const { printOptionsFiltersSelectedValues } = this.state;

        this.setState({
            printOptionsFiltersSelectedValues: {
                ...printOptionsFiltersSelectedValues,
                [filterName]: filterValue
            }
        });
    }

    directPrintOneStudent() {
        const studentId = this.getStudentIdFromLocalStorage();
        const student = this.getStudentFromLocalStorage();

        if (!studentId || !this.state.printOptionsData) {
            console.log('Nedostaje student id ili print options data');
            return;
        }

        const params = buildPrintOptionFiltersParamsObject({
            ...this.state.printOptionsFiltersSelectedValues,
            ids: [studentId],
            facultyId: student && student.organizationalUnitId ? student.organizationalUnitId : null,
            studyCycle: student && student.studyCycleId ? student.studyCycleId : null,
            languages: this.state.printOptionsData.languages,
            withLogo: this.state.printOptionsFiltersSelectedValues.withLogo,
            documentVersion: this.state.printOptionsFiltersSelectedValues.documentVersion,
            alphabet: this.state.printOptionsFiltersSelectedValues.alphabet
        });

        this.setState({ directPrintLoading: true });
        axios({
            method: 'post',
            url: '/graduation-documents/print',
            responseType: 'blob',
            data: { ...params }
        })
            .then(async res => {
                const fileName = extractFileNameFromHeaders(res.headers);

                if (this.state.studentService) {
                    const watermarkedBlob = await addPreviewWatermarkToPdf(res.data);
                    download(watermarkedBlob, 'Probno_stampanje_' + fileName, 'application/pdf');
                } else {
                    download(res.data, fileName);
                }
                this.setState({ directPrintLoading: false });
            })
            .catch(err => {
                console.log('failed to download document');
                this.setState({ directPrintLoading: false });
            });
    }

    render() {
        if (!this.state.ready) {
            return null;
        }
        const panes = [
            ((this.state.studentService || this.state.admin) && this.props.graduated === true) ? {
                menuItem: 'Pregled diplome',
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        {this.state.printOptionsData && (
                            <Options
                                oneStudent
                                initialAvailableValuesList={this.state.printOptionsData}
                                printOptionsFiltersSelectedValues={this.state.printOptionsFiltersSelectedValues}
                                printOptionsFiltersAvailableValuesList={this.state.printOptionsData}
                                onPrintOptionsFilterChange={this.onPrintOptionsFilterChange}
                                onDirectPrint={this.directPrintOneStudent}
                                directPrintLoading={this.state.directPrintLoading}
                                studentService={this.state.studentService}
                                admin={this.state.admin}
                            />
                        )}
                    </Tab.Pane>
                )
            } : null,
            ((this.state.studentService || this.state.admin) && this.props.graduated === true) ? {
                menuItem: 'Status diplome',
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <DiplomaStatus
                            studentStudyProgramId={this.props.studentStudyProgramId}
                            studentService={this.state.studentService}
                            admin={this.state.admin}
                            limitation={this.state.limitation}
                        />
                    </Tab.Pane>
                )
            } : null,

            (this.state.studentService && (!this.props.locked || this.props.graduated)) ? {
                menuItem: 'Izdavanje dokumenata',
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <NewStudentCertificate />
                    </Tab.Pane>
                )
            } : null,

            {
                menuItem: 'Izdati dokumenti',
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <PreviousCertificates
                            studentId={this.props.studentId}
                            studyProgramId={this.props.studyProgramId}
                        />
                    </Tab.Pane>
                )
            }
        ].filter(Boolean);

        return (
            <div>
                <Tab
                    panes={panes}
                    menu={{
                        secondary: true,
                        pointing: true,
                        color: 'blue',
                        vertical: true,
                        fluid: true,
                        attached: true,
                        tabular: true
                    }}
                    defaultActiveIndex={0}
                    grid={{ paneWidth: 13, tabWidth: 3 }}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentCertificates.js